"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetrieveOrdersOptions = void 0;
/* eslint-disable no-param-reassign */
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const SortingPaginationOptions_1 = require("./SortingPaginationOptions");
let RetrieveOrdersOptions = class RetrieveOrdersOptions extends SortingPaginationOptions_1.SortingPaginationOptions {
};
exports.RetrieveOrdersOptions = RetrieveOrdersOptions;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value)
        ? undefined
        : value.map((item) => String(item))),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "ids", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RetrieveOrdersOptions.prototype, "bundleId", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value)),
    __metadata("design:type", Date)
], RetrieveOrdersOptions.prototype, "createdAtFrom", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value)),
    __metadata("design:type", Date)
], RetrieveOrdersOptions.prototype, "createdAtTo", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value)),
    __metadata("design:type", Date)
], RetrieveOrdersOptions.prototype, "departureAtFrom", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value)),
    __metadata("design:type", Date)
], RetrieveOrdersOptions.prototype, "departureAtTo", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value)),
    __metadata("design:type", Date)
], RetrieveOrdersOptions.prototype, "arrivalTimeTo", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value)),
    __metadata("design:type", Date)
], RetrieveOrdersOptions.prototype, "confirmedAtFrom", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value)),
    __metadata("design:type", Date)
], RetrieveOrdersOptions.prototype, "confirmedAtTo", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value)
        ? undefined
        : value.map((item) => String(item))),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "originLocationIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value)
        ? undefined
        : value.map((item) => String(item))),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "destinationLocationIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value)
        ? undefined
        : value.map((item) => String(item))),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "contentLocationIds", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveOrdersOptions.prototype, "hasDiscountId", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value)
        ? undefined
        : value.map((item) => String(item))),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "discountIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => {
        if ((0, utils_1.isUndefinedOrNull)(value)) {
            return undefined;
        }
        if (!Array.isArray(value)) {
            value = [value];
        }
        return value.map((item) => String(item));
    }),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "userIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => {
        if ((0, utils_1.isUndefinedOrNull)(value)) {
            return undefined;
        }
        if (!Array.isArray(value)) {
            value = [value];
        }
        return value.map((item) => String(item));
    }),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "apiPartnerIds", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RetrieveOrdersOptions.prototype, "voucher", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value)
        ? undefined
        : value.map((item) => String(item))),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "driverIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value)
        ? undefined
        : value.map((item) => Number(item))),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "statusIn", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value)
        ? undefined
        : value.map((item) => Number(item))),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "vehicleTypesIn", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveOrdersOptions.prototype, "isPickupAddressApproved", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveOrdersOptions.prototype, "isDropoffAddressApproved", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "emailTypesSent", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "emailTypesNotSent", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveOrdersOptions.prototype, "isFeedbackRequestDisabled", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveOrdersOptions.prototype, "isDepositRequired", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveOrdersOptions.prototype, "onlyApiPartnerOrders", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveOrdersOptions.prototype, "onlyTravelAgentOrders", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveOrdersOptions.prototype, "onlyVIPOrders", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RetrieveOrdersOptions.prototype, "search", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value)
        ? undefined
        : value.map((item) => String(item))),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "originCountryIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value)
        ? undefined
        : value.map((item) => String(item))),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "destinationCountryIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.isUndefinedOrNull)(value)
        ? undefined
        : value.map((item) => String(item))),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "passengerCountryIds", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveOrdersOptions.prototype, "hasStops", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveOrdersOptions.prototype, "hasChild", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RetrieveOrdersOptions.prototype, "maxPrice", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "automaticEmailMailgunIds", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RetrieveOrdersOptions.prototype, "partnerId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RetrieveOrdersOptions.prototype, "apiPartnerId", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "paymentMethods", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RetrieveOrdersOptions.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RetrieveOrdersOptions.prototype, "offerType", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => {
        if ((0, utils_1.isUndefinedOrNull)(value)) {
            return undefined;
        }
        if (!Array.isArray(value)) {
            value = [value];
        }
        return value.map((item) => String(item));
    }),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "hostAgencyIds", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.AirportTransferDirection, { each: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveOrdersOptions.prototype, "airportTransferDirection", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RetrieveOrdersOptions.prototype, "travelAgentCategory", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RetrieveOrdersOptions.prototype, "travelAgentHostAgency", void 0);
exports.RetrieveOrdersOptions = RetrieveOrdersOptions = __decorate([
    (0, class_transformer_1.Exclude)()
], RetrieveOrdersOptions);
//# sourceMappingURL=RetrieveOrdersOptions.js.map